/**
 * PlatformUserEvents
 * Registry of events for the Protocol pages
 */
export enum PlatformUserEvents {
    TableLinkClick = "Platform - Table - Click Individual Page Link",
    ClickIndividualWebsite = "Platform - Individual Header - Click Website",
    ClickIndividualTaxonomyBadge = "Platform - Individual Header - Click Taxonomy Badge",
    ChangeNetFlowsIncludeStablecoins = "Platform - Net Flows - Change Include Stablecoins",
    ChangeNetFlowsChangeTimeframe = "Platform - Net Flows - Change Timeframe",
    ChangePieChartIncludeStablecoins = "Platform - Pie Chart - Change Include Stablecoins",
    IndividualPieChartChangeGroupBy = "Platform - Pie Chart - Change Group By",
    LeagueTableClickNetwork = "Platform - League Table - Click Network",
    LeagueTableClickAssetClass = "Platform - League Table - Click Asset Class",
    ClickAssetClassLink = "Platform - Table - Click Asset Class Link",
}
